<template>
<div class="member-social-share">
  <div class="text-xs-center">
        <v-bottom-sheet v-model="sheet">
            <v-btn slot="activator" outline small class="white text-capitalize caption my-1" color="white">
                <v-icon class="caption" left>mdi-share-variant</v-icon>
                Share
            </v-btn>
            <v-list>
                <v-subheader>Share in</v-subheader>
                <v-list-tile v-for="tile in tiles" :key="tile.title" @click="sheet = false">
                    <v-list-tile-avatar>
                        <v-avatar size="32px" tile>
                            <img :src="tile.src" :alt="tile.title">
                        </v-avatar>
                    </v-list-tile-avatar>
                    <v-list-tile-title>{{ tile.title }}</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-bottom-sheet>
    </div>
</div>
</template>
<script>
    export default {
        data: () => ({
            sheet: false,
            tiles: [{
                    src: 'https://digima.sgp1.digitaloceanspaces.com/mybarko/social-icons/facebook.png',
                    title: 'Facebook'
                },
                {
                    src: 'https://digima.sgp1.digitaloceanspaces.com/mybarko/social-icons/twitter.png',
                    title: 'Twitter'
                },
                {
                    src: 'https://digima.sgp1.digitaloceanspaces.com/mybarko/social-icons/instagram.png',
                    title: 'Instagram'
                },
                {
                    src: 'https://digima.sgp1.digitaloceanspaces.com/mybarko/social-icons/whatsapp.png',
                    title: 'Whatsapp'
                }
            ]
        })
    }
</script>